/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Processing_Notice_TitleInputs */

const en_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI processing notice`)
};

const de_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis zur KI-Verarbeitung`)
};

const fr_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information sur le traitement par l’IA`)
};

const es_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de procesamiento con IA`)
};

const it_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avviso sul trattamento mediante IA`)
};

const nl_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kennisgeving over AI-verwerking`)
};

const pl_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacja o przetwarzaniu przez AI`)
};

const fi_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitus tekoälykäsittelystä`)
};

const da_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelelse om AI-behandling`)
};

const sv_ai_processing_notice_title = /** @type {(inputs: Ai_Processing_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelande om AI-behandling`)
};

/**
* | output |
* | --- |
* | "AI processing notice" |
*
* @param {Ai_Processing_Notice_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ai_processing_notice_title = /** @type {((inputs?: Ai_Processing_Notice_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Processing_Notice_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_processing_notice_title(inputs)
	if (locale === "fr") return fr_ai_processing_notice_title(inputs)
	if (locale === "es") return es_ai_processing_notice_title(inputs)
	if (locale === "it") return it_ai_processing_notice_title(inputs)
	if (locale === "nl") return nl_ai_processing_notice_title(inputs)
	if (locale === "pl") return pl_ai_processing_notice_title(inputs)
	if (locale === "fi") return fi_ai_processing_notice_title(inputs)
	if (locale === "da") return da_ai_processing_notice_title(inputs)
	if (locale === "sv") return sv_ai_processing_notice_title(inputs)
	return en_ai_processing_notice_title(inputs)
});